// Dependencies
import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

// Images
import left from '../../../sass/images/slider/left.svg';
import right from '../../../sass/images/slider/right.svg';

function Arrow({ type, onClick, ...props }) {
  const { t } = props;
  const className = type === 'next' ? 'nextArrow' : 'prevArrow';

  return (
    <span className={`${className} arrow`} onClick={onClick}>
      {type === 'next' ? <img src={right} alt={t('prev')} /> : <img src={left} alt={t('next')} />}
    </span>
  );
}

Arrow.propTypes = {
  onClick: PropTypes.func,
  type: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
};

Arrow.defaultProps = {
  onClick: () => {},
};

export default withTranslation('alt')(Arrow);
